module.exports = __webpack_public_path__ + "media/images/cc_logos/discover-56347c71b5c764bc6f93ab41ec19c98b.png";